// FilterFold — the "Filters (n)" disclosure of ReportToolbar, for a register on
// the app shell (no print toolbar). Below md the filters fold behind a 44px
// button that says how many are set; from md they lie inline, always open.
// The count and label come from ReportToolbar so the two folds read the same.
import { useId, useState, type ReactNode } from 'react'
import { ChevronDown, SlidersHorizontal } from 'lucide-react'
import { filtersLabel } from '@/components/ReportToolbar'

export default function FilterFold({ activeFilters, children, className = '', foldAtAllWidths = false }: {
  /** Filters changed from the register's defaults — see activeFilterCount. */
  activeFilters: number
  children: ReactNode
  /** Classes for the band that holds the toggle and the filters. */
  className?: string
  /** Opt in to folding from md up as well (default: lies open from md). */
  foldAtAllWidths?: boolean
}) {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  return (
    <div className={className}>
      <button type="button" onClick={() => setOpen(v => !v)}
        aria-expanded={open} aria-controls={panelId}
        className={`${foldAtAllWidths ? '' : 'md:hidden '}px-3 min-h-[44px] rounded-lg border surface hairline-strong text-fg-secondary hover:bg-raised flex items-center gap-1.5 text-sm`}>
        <SlidersHorizontal size={15} aria-hidden="true" />
        {filtersLabel(activeFilters)}
        <ChevronDown size={14} aria-hidden="true" className={`transition-transform${open ? ' rotate-180' : ''}`} />
      </button>
      <div id={panelId} data-filter-fold="panel"
        className={`${open ? 'block' : 'hidden'}${foldAtAllWidths ? ' mt-2' : ' md:block mt-2 md:mt-0'}`}>
        {children}
      </div>
    </div>
  )
}
